import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/context/AuthContext";
import { PLATFORM_TAGS, byKey } from "@/lib/platforms";
import { ArrowLeft } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    axios.get(`${API}/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setMissing(true));
  }, [slug]);

  if (missing) {
    return (
      <main className="pt-16 max-w-2xl mx-auto px-5 py-24" data-testid="blog-post-missing">
        <h1 className="font-display text-3xl">That post is not here</h1>
        <Link to="/blog" className="inline-flex items-center gap-2 mt-4 font-semibold">
          <ArrowLeft size={16} /> Back to the blog
        </Link>
      </main>
    );
  }
  if (!post) return <main className="pt-16 min-h-[60vh]" />;

  const tag = PLATFORM_TAGS[post.platform] || PLATFORM_TAGS.general;
  const platform = byKey(post.platform);

  return (
    <main className="pt-16" data-testid="blog-post-page">
      <section style={{ background: platform ? platform.soft : "var(--paper-deep)" }}>
        <div className="max-w-2xl mx-auto px-5 sm:px-8 pt-14 pb-12">
          <Link to="/blog" className="inline-flex items-center gap-2 text-sm font-semibold hover:opacity-60 transition-opacity" data-testid="post-back-link">
            <ArrowLeft size={15} /> The blog
          </Link>
          <p className="kicker mt-6" style={{ color: tag.hue }}>{tag.name}</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-3 leading-[1.08]">{post.title}</h1>
          <p className="mt-4 text-sm font-mono-nc text-[var(--ink-soft)]">{post.author} · {post.read_minutes} min · {post.published_at}</p>
        </div>
      </section>
      <article className="max-w-2xl mx-auto px-5 sm:px-8 py-12 space-y-6">
        {post.body.map((para, i) => (
          <p key={i} className={`leading-relaxed ${i === 0 ? "text-lg font-medium" : "text-[var(--ink-soft)] text-base"}`}>
            {para}
          </p>
        ))}
        {platform && (
          <Link
            to={platform.path}
            className="block rounded-3xl p-6 text-white grain relative overflow-hidden mt-10 hover:-translate-y-1 transition-transform"
            style={{ background: platform.hue }}
            data-testid="post-platform-cta"
          >
            <p className="font-mono-nc text-xs opacity-80">{platform.num}</p>
            <p className="font-display text-2xl mt-1">{platform.name}</p>
            <p className="text-sm opacity-90 mt-1">This post lives there. So does everything around it.</p>
          </Link>
        )}
      </article>
    </main>
  );
}
